import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, Icon, toast } from '@livable/saas-react-components';
import { Button, Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { YEmailValidateDefault } from 'src/utils/formValidation/yupValidators';
import useSendReportModalContentStyles from './styles';

// ? i18n
const SendReportModalContent = observer(props => {
  const classes = useSendReportModalContentStyles();
  const history = useLocation();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const parameters = new URLSearchParams(history.search);
  const propertyId = parameters.get('propertyId');
  const handleModalClose = props.handleModalClose,
    properties = props.properties;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    emails = _useState4[0],
    setEmails = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isAllValid = _useState6[0],
    setIsAllValid = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSendingReport = _useState8[0],
    setIsSendingReport = _useState8[1];
  const isDisabled = !isAllValid || checked.length === 0 && emails.length === 0 || isSendingReport;
  const handleSubmit = async () => {
    const membersEmails = store.teamMembers.getTeamMember(false).filter(member => checked.includes(member.id)).map(member => member.email || member.newEmail).filter(Boolean);
    setIsSendingReport(true);
    const resp = await store.report.sendReportAsync.run({
      propertyIds: properties.length ? [...properties.map(property => property.propertyId)] : [propertyId],
      emails: [...membersEmails, ...emails]
    }).finally(() => setIsSendingReport(false));
    if (resp !== null && resp !== void 0 && resp.isSuccessful) toast('success', {
      body: ['Report sent successfully']
    });else toast('error', {
      body: ['Failed to send report']
    });
    handleModalClose(false);
  };
  const handleChangeEmail = (i, value) => {
    const newEmails = [...emails];
    newEmails[i] = value.trim();
    setEmails(newEmails);
  };
  let schema = yup.object().shape({
    emails: yup.array().of(yup.string().trim().email())
  });
  schema.isValid({
    emails
  }).then(valid => setIsAllValid(valid && emails.every(email => email && YEmailValidateDefault.isValidSync(email))));
  const handleDeleteEmail = email => setEmails(emails.filter(elem => elem !== email));
  const handleToggle = id => setChecked(checked.indexOf(id) === -1 ? [...checked, id] : checked.filter(item => item !== id));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Select to whom AR report should be sent"), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(List, {
    variant: "classic"
  }, store.teamMembers.getTeamMember(false).map(member => /*#__PURE__*/React.createElement(ListItem, {
    disablePadding: true,
    key: member.id
  }, /*#__PURE__*/React.createElement(ListItemButton, {
    dense: true,
    onClick: () => handleToggle(member.id),
    role: undefined
  }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked.indexOf(member.id) !== -1,
    edge: "start",
    disableRipple: true
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: "".concat(member.firstName, " ").concat(member.lastName)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Additional receivers"), emails.map((elem, i) => {
    const isValid = YEmailValidateDefault.isValidSync(elem);
    return /*#__PURE__*/React.createElement("div", {
      className: classes.personForm,
      key: i
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.flexGrow
    }, /*#__PURE__*/React.createElement(TextField, {
      label: t('general.email'),
      variant: "outlined",
      fullWidth: true,
      onChange: e => handleChangeEmail(i, e.target.value),
      error: !isValid,
      helperText: !isValid && 'Invalid email',
      value: elem
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "large",
      onClick: () => handleDeleteEmail(elem),
      'custom-attribute': '3-send-report-modal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "delete"
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isSendingReport,
    onClick: () => {
      setEmails([...emails, '']);
    },
    size: "small",
    variant: "contained",
    'custom-attribute': '4-send-report-modal'
  }, t('enrollment_modal.add_person')))))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleModalClose(false),
    'custom-attribute': '5-send-report-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabled,
    onClick: handleSubmit,
    variant: "contained",
    'custom-attribute': '6-send-report-modal'
  }, t('reporting.send_report'))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isSendingReport
  }));
});
export default SendReportModalContent;